import React from 'react';

import { flagStyles } from '../settings';

const SvgLV = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3192px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLV;
